<template>
  <el-select
    v-model="valueBackup"
    :placeholder="placeholder"
    clearable
    filterable
    remote
    :remote-method="search"
    @change="handleChange"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.title"
      :value="item.id"
    >
      <span v-html="getKeywordHtml('名称', item.title)" class="item"></span>，
      税率：<b>{{ item.tax_rate | toYuan }} %</b>
    </el-option>
  </el-select>
</template>

<script>
import { mapGetters } from 'vuex';
import { index } from '@/api/invoice-class';

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '请输入类目名称进行搜索',
    },
  },
  data: () => ({
    valueBackup: '',
    list: [],
    keyword: '',
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackup) this.valueBackup = value;
    },
    valueBackup(valueBackup) {
      if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    getKeywordHtml(label, words) {
      words = `${words}`.replace(
        RegExp(this.keyword, 'i'),
        (keyword) => `<span class='primary-color'>${keyword}</span>`,
      );
      return `${label}：<b>${words}</b>`;
    },
    handleChange(id) {
      if (!id) return this.$emit('change', 0);

      const { list } = this;
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === id) return this.$emit('change', list[i].tax_rate);
      }
    },
    async search(keyword) {
      this.keyword = keyword;
      const { isError, data } = await index({ keyword });
      if (!isError) this.list = data.list || [];
    },
  },
  beforeMount() {
    this.valueBackup = this.value || '';
    this.search('');
  },
};
</script>
